import cx from 'classnames'
import isFunction from 'lodash/isFunction'
import { FC, ReactNode, useEffect, useState } from 'react'

import Button from 'src/components/ui/atoms/Button'
import Modal from 'src/components/ui/atoms/Modal'

import * as styles from './styles.scss'

export interface ConfirmModalProps {
  isOpen: boolean
  title?: string
  message: ReactNode
  onConfirmClick: () => void
  onCancelClick?: () => void
  isControlled?: boolean
  bodyClassName?: string
  confirmButtonLabel?: string
  disableAllActions?: boolean
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onConfirmClick,
  onCancelClick,
  isControlled,
  bodyClassName,
  confirmButtonLabel = 'Confirm',
  disableAllActions,
}) => {
  const [open, setOpen] = useState(false)

  const handleConfirmClick = () => {
    if (disableAllActions) {
      return
    }
    onConfirmClick && onConfirmClick()
    if (!isControlled) {
      setOpen(false)
    }
  }

  const handleCancelClick = () => {
    if (disableAllActions) {
      return
    }
    onCancelClick && onCancelClick()
    setOpen(false)
  }

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  return (
    <Modal
      hideCloseIcon={disableAllActions}
      open={open}
      onRequestClose={handleCancelClick}
      className={styles.ConfirmModal}
    >
      {title && <Modal.Header>{isFunction(title) ? title() : title}</Modal.Header>}
      <Modal.Body className={cx(styles.Body, { [styles.BodyWithoutTitle]: !title }, bodyClassName)}>
        {isFunction(message) ? message() : message}
      </Modal.Body>
      <Modal.Footer>
        <Button
          buttonType="silence"
          className={styles.Button}
          disabled={disableAllActions}
          onClick={handleCancelClick}
        >
          <div>Cancel</div>
        </Button>
        <Button
          buttonType="primary"
          className={styles.Button}
          disabled={disableAllActions}
          onClick={handleConfirmClick}
        >
          <div>{confirmButtonLabel}</div>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmModal
